const v = "v1";

const env = { baseUrl: `http://20.24.57.193:3001/api/${v}/`, socketBaseUrl: "20.24.57.193:3001" };
const appUrl = {
    ...env,
    login: "adminAuthentication/login",
    getAdminUserList: "adminUser",
};
export default appUrl;
